<template>
    <div class="barra-filtros-flotante">
        <!-- Controles de Vista -->
        <div class="controles-vista">
            <!-- 1. Ficha del Paciente -->
            <button
:class="{ 'panel-activo': modoAccion === 'perfil-paciente' }"
                title="Ver información personal y datos generales del paciente" @click="verPerfilPaciente">
                <span class="btn-label">Ficha</span>
            </button>

            <!-- 2. Historia Clínica Completa -->
            <button
:class="{ 'panel-activo': modoAccion === 'historia-clinica' }"
                title="Ver historia clínica completa con todos los antecedentes" @click="verHistoriaClinica">
                <span class="btn-label">Historia Clínica</span>
            </button>

            <!-- 3. Buscar -->
            <button
:class="{ 'activo': mostrarFiltrosAvanzados }" title="Buscar y filtrar registros por fecha o tipo"
                @click="toggleFiltrosAvanzados">
                <span class="btn-label">Buscar</span>
            </button>

            <!-- Separador visual -->
            <div class="separador-vertical"></div>
        </div>

        <!-- Filtros Rápidos por Icono (Centro) -->
        <div class="filtros-rapidos">
            <!-- 4. Nota médica -->
            <button
:class="{ 'activo': modoAccion === 'nueva-nota' }" title="Crear una nueva nota médica de evolución"
                @click="nuevaNotaMedica">
                <span class="btn-label">Nota</span>
            </button>

            <!-- 5. Receta -->
            <button
:class="{ 'activo': modoAccion === 'nueva-receta' }"
                title="Generar una nueva receta médica con medicamentos" @click="nuevaReceta">
                <span class="btn-label">Receta</span>
            </button>

            <!-- 6. Reporte -->
            <button
:class="{ 'activo': modoAccion === 'nuevo-reporte' }"
                title="Crear un reporte médico con imágenes y estudios" @click="nuevoReporte">
                <span class="btn-label">Reporte</span>
            </button>

            <!-- Separador visual -->
            <div class="separador-vertical"></div>

            <!-- 7. Subsecuentes (Historial timeline) -->
            <button
:class="{ 'activo': modoAccion === 'ver-historial' }"
                title="Ver historial de notas y eventos clínicos" @click="verHistorialNotas">
                <span class="btn-label">Subsecuentes</span>
            </button>

            <!-- Separador visual -->
            <div class="separador-vertical"></div>

            <!-- 8. Documentos -->
            <button
:class="{ 'activo': modoAccion === 'documentos' }"
                title="Ver y gestionar todos los documentos del paciente" @click="verDocumentos">
                <span class="btn-label">Documentos</span>
            </button>

            <!-- 9. Seguimiento (Alertas, Alergias, Gráficas) -->
            <div
class="submenu-wrapper" @mouseenter="mostrarSubmenuInfo = true"
                @mouseleave="mostrarSubmenuInfo = false">
                <button
                    :class="{ 'activo': modoAccion === 'alertas-paciente' || modoAccion === 'alergias' || modoAccion === 'signos-vitales' || modoAccion === 'datos-paciente' }"
                    title="Seguimiento del paciente: Alertas, Alergias, Gráficas y Datos">
                    <span class="btn-label">Seguimiento</span>
                    <i class="fas fa-chevron-down submenu-icon"></i>
                </button>

                <transition name="submenu-fade">
                    <div v-if="mostrarSubmenuInfo" class="submenu-dropdown">
                        <button
:class="{ 'activo': modoAccion === 'alertas-paciente' }" class="submenu-item"
                            title="Ver alertas importantes del paciente (alergias, medicamentos, etc.)"
                            @click="verAlertas">
                            <i class="fas fa-bell submenu-item-icon"></i>
                            <span>Alertas</span>
                        </button>

                        <button
:class="{ 'activo': modoAccion === 'alergias' }" class="submenu-item"
                            title="Gestionar alergias y reacciones adversas del paciente" @click="gestionarAlergias">
                            <i class="fas fa-triangle-exclamation submenu-item-icon"></i>
                            <span>Alergias</span>
                        </button>

                        <button
:class="{ 'activo': modoAccion === 'signos-vitales' }" class="submenu-item"
                            title="Registrar y visualizar signos vitales (presión, temperatura, etc.)"
                            @click="verSignosVitales">
                            <i class="fas fa-chart-line submenu-item-icon"></i>
                            <span>Gráficas</span>
                        </button>

                        <button
:class="{ 'activo': modoAccion === 'datos-paciente' }" class="submenu-item"
                            title="Ver datos tabulares del paciente en formato grid"
                            @click="verDatosPaciente">
                            <i class="fas fa-table submenu-item-icon"></i>
                            <span>Datos</span>
                        </button>
                    </div>
                </transition>
            </div>

            <!-- Separador visual -->
            <div class="separador-vertical"></div>
        </div>

        <!-- Botones de acciones al final -->
        <div class="acciones-final">
            <!-- Navegación (historial de navegación) -->
            <button
:class="{ 'panel-activo': mostrarHistorialReciente }" title="Historial de navegación"
                aria-label="Navegación" @click="toggleHistorialReciente">
                <i class="fa-solid fa-clock-rotate-left"></i>
            </button>

            <!-- Panel de acciones -->
            <button
:class="{ 'panel-activo': !isLeftPanelCollapsed }" :title="panelAccionesTitle" :aria-label="panelAccionesTitle"
                @click="togglePanelAcciones">
                <i :class="panelAccionesIcon"></i>
            </button>
        </div>

        <!-- Panel de Filtros Avanzados - REDISEÑADO MODAL COMPLETO -->
        <Teleport to="body">
            <div v-if="mostrarFiltrosAvanzados">
                <div class="modal-backdrop-filtros animated-backdrop" @click="mostrarFiltrosAvanzados = false"></div>
                <div class="modal-dialog-filtros modal-animated-filtros">
                    <div class="panel-filtros-avanzados">
                        <div class="filtros-avanzados-content">
                            <!-- Header -->
                            <div class="filtros-header">
                                <div class="header-icon">
                                    <i class="fas fa-filter"></i>
                                </div>
                                <div class="header-text">
                                    <h3 class="filtros-titulo">Filtros Avanzados</h3>
                                    <p class="filtros-subtitulo">Personaliza tu búsqueda</p>
                                </div>
                                <button
class="btn-cerrar-filtros" title="Cerrar"
                                    @click="mostrarFiltrosAvanzados = false">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>

                            <!-- Sección: Tipo de Documento -->
                            <div class="filtro-seccion">
                                <div class="seccion-header">
                                    <i class="fas fa-file-alt seccion-icono"></i>
                                    <label class="seccion-label">Tipo de Documento</label>
                                </div>
                                <div class="selector-tipo-nuevo">
                                    <ChoicesSelect
v-model="tipoDocumento" :options="tipoDocumentoOptions"
                                        placeholder="Selecciona un tipo" />
                                </div>
                            </div>

                            <!-- Sección: Período de Tiempo -->
                            <div class="filtro-seccion">
                                <div class="seccion-header">
                                    <i class="fas fa-calendar seccion-icono"></i>
                                    <label class="seccion-label">Período de Tiempo</label>
                                </div>

                                <!-- Botones de filtro rápido -->
                                <div class="filtros-tiempo-grid">
                                    <button
:class="['filtro-tiempo-btn', { active: filtro === 'recientes' }]"
                                        @click="seleccionarFiltro('recientes')">
                                        <div class="filtro-tiempo-icono">
                                            <i class="fas fa-clock"></i>
                                        </div>
                                        <div class="filtro-tiempo-texto">
                                            <span class="filtro-tiempo-titulo">Recientes</span>
                                            <span class="filtro-tiempo-desc">Última semana</span>
                                        </div>
                                    </button>

                                    <button
:class="['filtro-tiempo-btn', { active: filtro === 'mes' }]"
                                        @click="seleccionarFiltro('mes')">
                                        <div class="filtro-tiempo-icono">
                                            <i class="fas fa-calendar-alt"></i>
                                        </div>
                                        <div class="filtro-tiempo-texto">
                                            <span class="filtro-tiempo-titulo">Por Mes</span>
                                            <span class="filtro-tiempo-desc">Selecciona mes</span>
                                        </div>
                                    </button>

                                    <button
:class="['filtro-tiempo-btn', { active: filtro === 'fecha' }]"
                                        @click="seleccionarFiltro('fecha')">
                                        <div class="filtro-tiempo-icono">
                                            <i class="fas fa-calendar-week"></i>
                                        </div>
                                        <div class="filtro-tiempo-texto">
                                            <span class="filtro-tiempo-titulo">Rango</span>
                                            <span class="filtro-tiempo-desc">Fecha inicio-fin</span>
                                        </div>
                                    </button>
                                </div>

                                <!-- Opciones expandibles según selección -->
                                <transition name="expand">
                                    <div v-if="filtro === 'mes'" class="filtro-expandido">
                                        <div class="input-group-moderno">
                                            <label class="input-label-moderno">
                                                <i class="fas fa-calendar-day"></i>
                                                Selecciona el mes y año
                                            </label>
                                            <DatePicker
v-model="mesSeleccionado" :errors="{}" error-field-name="mes"
                                                mode="month" placeholder="Selecciona mes y año" />
                                        </div>
                                    </div>
                                </transition>

                                <transition name="expand">
                                    <div v-if="filtro === 'fecha'" class="filtro-expandido">
                                        <div class="fecha-rango-container">
                                            <div class="input-group-moderno">
                                                <label class="input-label-moderno">
                                                    <i class="fas fa-calendar-plus"></i>
                                                    Fecha de inicio
                                                </label>
                                                <DatePicker
v-model="fechaInicio" :errors="{}"
                                                    error-field-name="fechaInicio"
                                                    placeholder="Seleccionar fecha de inicio" />
                                            </div>
                                            <div class="separador-fecha">
                                                <i class="fas fa-arrow-right"></i>
                                            </div>
                                            <div class="input-group-moderno">
                                                <label class="input-label-moderno">
                                                    <i class="fas fa-calendar-check"></i>
                                                    Fecha de fin
                                                </label>
                                                <DatePicker
v-model="fechaFin" :errors="{}" error-field-name="fechaFin"
                                                    placeholder="Seleccionar fecha de fin" />
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>

                            <!-- Footer con acciones -->
                            <div class="filtros-footer">
                                <button class="btn-limpiar" @click="limpiarFiltros">
                                    <i class="fas fa-eraser"></i>
                                    Limpiar
                                </button>
                                <button class="btn-aplicar-moderno" @click="aplicarFiltrosSeleccionados">
                                    <i class="fas fa-search"></i>
                                    Aplicar Filtros
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Teleport>

        <!-- Panel de Historial Reciente -->
        <transition name="slide-down">
            <div v-if="mostrarHistorialReciente" class="panel-historial-reciente-moderno">
                <HistorialNavegacion
:items="historialReciente" @seleccionar="irAHistorial"
                    @cerrar="mostrarHistorialReciente = false" />
            </div>
        </transition>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useMedicalWorkspace } from '@/composables/useMedicalWorkspace';
import HistorialNavegacion from './HistorialNavegacion.vue';
import ChoicesSelect from '@/components/ChoicesSelect.vue';
import DatePicker from '@/components/DatePicker.vue';

defineProps({
    leftPanelCollapsed: Boolean,
    rightPanelCollapsed: Boolean
});

const emit = defineEmits(['toggle-panel', 'filtrar', 'filtrar-avanzado']);

// Usar el composable para manejar filtros avanzados y navegación
/* eslint-disable no-unused-vars */
const {
    aplicarFiltroAvanzado: aplicarFiltroAvanzadoGlobal,
    activarModoAccion,
    modoAccion,
    detalleSeleccionado,
    isDetailPanelExpanded,
    toggleDetailExpansion,
    isLeftPanelCollapsed,
    togglePanel,
    historialNavegacion, // 🆕 Usar directamente el historial global
} = useMedicalWorkspace();
/* eslint-enable no-unused-vars */

const mostrarFiltrosAvanzados = ref(false);
const mostrarHistorialReciente = ref(false);
const mostrarSubmenuInfo = ref(false);
const filtro = ref('recientes');
const tipoDocumento = ref('todo');
const fechaInicio = ref('');
const fechaFin = ref('');
const mesSeleccionado = ref('');

// Opciones para el selector de tipo de documento
const tipoDocumentoOptions = [
    { id: 'todo', text: 'Todos' },
    { id: 'nota-medica', text: 'Notas médicas' },
    { id: 'receta', text: 'Recetas' },
    { id: 'reporte', text: 'Reportes' },
    { id: 'documento', text: 'Archivos' },
    { id: 'signos-vitales', text: 'Signos vitales' },
    { id: 'alertas', text: 'Alertas' },
    { id: 'alergias', text: 'Alergias' }
];

// Obtener TODO el historial - SIN LÍMITE
const historialReciente = computed(() => {
    if (!Array.isArray(historialNavegacion.value)) {
        console.error('❌ BarraFiltrosFlotante - historialNavegacion NO es un array!');
        return [];
    }

    // Invertir para mostrar los más recientes primero
    const invertido = [...historialNavegacion.value].reverse();

    return invertido;
});

const panelAccionesIcon = computed(() => isLeftPanelCollapsed.value ? 'fa-solid fa-angles-right' : 'fa-solid fa-angles-left');
const panelAccionesTitle = computed(() => isLeftPanelCollapsed.value ? 'Mostrar panel de acciones' : 'Ocultar panel de acciones');

const toggleFiltrosAvanzados = () => {
    mostrarFiltrosAvanzados.value = !mostrarFiltrosAvanzados.value;
    if (mostrarFiltrosAvanzados.value) {
        mostrarHistorialReciente.value = false;
    }
};

const toggleHistorialReciente = () => {
    mostrarHistorialReciente.value = !mostrarHistorialReciente.value;
    if (mostrarHistorialReciente.value) {
        mostrarFiltrosAvanzados.value = false;
    }
};

// Función para ir a una página del historial
const irAHistorial = (item) => {
    // Cerrar el popup
    mostrarHistorialReciente.value = false;
    // Activar el modo correspondiente
    activarModoAccion(item.modo, item.titulo);
};

// Función para obtener el icono según el modo
// eslint-disable-next-line no-unused-vars
const obtenerIconoModo = (modo) => {
    const iconos = {
        'perfil-paciente': 'fa-solid fa-user-circle',
        'historia-clinica': 'fa-solid fa-file-medical-alt',
        'nueva-nota': 'fa-solid fa-file-medical',
        'nueva-receta': 'fa-solid fa-prescription',
        'nuevo-reporte': 'fa-solid fa-file-image',
        'documentos': 'fa-solid fa-folder-open',
        'signos-vitales': 'fa-solid fa-heart-pulse',
        'alergias': 'fa-solid fa-triangle-exclamation',
        'expediente-completo': 'fa-solid fa-book-medical',
        'ver-historial': 'fa-solid fa-list-timeline',
        'alertas-paciente': 'fa-solid fa-bell',
    };
    return iconos[modo] || 'fa-solid fa-file';
};

// Función para formatear la fecha/hora
// eslint-disable-next-line no-unused-vars
const formatearFecha = (timestamp) => {
    const ahora = new Date();
    const fecha = new Date(timestamp);
    const diffMs = ahora - fecha;
    const diffDays = Math.floor(diffMs / 86400000);

    const hora = fecha.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });

    // Hoy
    if (diffDays === 0) {
        return `Hoy, ${hora}`;
    }

    // Ayer
    if (diffDays === 1) {
        return `Ayer, ${hora}`;
    }

    // Esta semana (2-6 días)
    if (diffDays < 7) {
        const nombreDia = fecha.toLocaleDateString('es-ES', { weekday: 'short' });
        return `${nombreDia}, ${hora}`;
    }

    // Más de una semana
    return fecha.toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit'
    });
};

const seleccionarFiltro = (tipo) => {
    filtro.value = tipo;
    // No cerramos el modal automáticamente al seleccionar un filtro rápido
    // El usuario debe hacer clic en "Aplicar Filtros"
};

// Nueva función para aplicar filtros seleccionados
// Esta función combina el filtro de tipo de documento con el filtro de fecha
// y envía un objeto único con todos los criterios de filtrado
const aplicarFiltrosSeleccionados = () => {
    let filtroData = {};

    // Construir objeto de filtro combinado:
    // - tipo: tipo de filtro temporal (recientes/mes/fecha)
    // - documento: tipo de documento a filtrar
    // - mes/inicio/fin: parámetros adicionales según el tipo

    if (filtro.value === 'recientes') {
        filtroData = { tipo: 'recientes', documento: tipoDocumento.value };
    } else if (filtro.value === 'mes') {
        if (!mesSeleccionado.value) {
            alert('Por favor selecciona un mes');
            return;
        }
        filtroData = { tipo: 'mes', mes: mesSeleccionado.value, documento: tipoDocumento.value };
    } else if (filtro.value === 'fecha') {
        if (!fechaInicio.value || !fechaFin.value) {
            alert('Por favor selecciona ambas fechas');
            return;
        }
        filtroData = { tipo: 'fecha', inicio: fechaInicio.value, fin: fechaFin.value, documento: tipoDocumento.value };
    }

    mostrarFiltrosAvanzados.value = false;
    aplicarFiltroAvanzadoGlobal(filtroData);
    emit('filtrar-avanzado', filtroData);

    // Activar automáticamente la vista de historial para mostrar los resultados filtrados
    activarModoAccion('ver-historial');
};

// Nueva función para limpiar filtros
const limpiarFiltros = () => {
    filtro.value = 'recientes';
    tipoDocumento.value = 'todo';
    fechaInicio.value = '';
    fechaFin.value = '';
    mesSeleccionado.value = '';
};

// Métodos para activar modos de acción específicos
const verHistoriaClinica = () => {
    // Scroll suave a la barra de navegación
    const barraFiltros = document.querySelector('.barra-filtros-flotante');
    if (barraFiltros) {
        barraFiltros.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    activarModoAccion('historia-clinica');
};

const verHistorialNotas = () => {
    // Scroll suave a la barra de navegación
    const barraFiltros = document.querySelector('.barra-filtros-flotante');
    if (barraFiltros) {
        barraFiltros.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    activarModoAccion('ver-historial');
};

const verAlertas = () => {
    mostrarSubmenuInfo.value = false;
    // Scroll suave a la barra de navegación
    const barraFiltros = document.querySelector('.barra-filtros-flotante');
    if (barraFiltros) {
        barraFiltros.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    activarModoAccion('alertas-paciente');
};

// eslint-disable-next-line no-unused-vars
const mostrarHistorial = () => {
    activarModoAccion('ver-historial');
};

const nuevaNotaMedica = () => {
    // Scroll suave a la barra de navegación
    const barraFiltros = document.querySelector('.barra-filtros-flotante');
    if (barraFiltros) {
        barraFiltros.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    activarModoAccion('nueva-nota');
};

const nuevaReceta = () => {
    // Scroll suave a la barra de navegación
    const barraFiltros = document.querySelector('.barra-filtros-flotante');
    if (barraFiltros) {
        barraFiltros.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    activarModoAccion('nueva-receta');
};

const verDocumentos = () => {
    // Scroll suave a la barra de navegación
    const barraFiltros = document.querySelector('.barra-filtros-flotante');
    if (barraFiltros) {
        barraFiltros.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    activarModoAccion('documentos');
};

const nuevoReporte = () => {
    // Scroll suave a la barra de navegación
    const barraFiltros = document.querySelector('.barra-filtros-flotante');
    if (barraFiltros) {
        barraFiltros.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    activarModoAccion('nuevo-reporte');
};

const verSignosVitales = () => {
    mostrarSubmenuInfo.value = false;
    // Scroll suave a la barra de navegación
    const barraFiltros = document.querySelector('.barra-filtros-flotante');
    if (barraFiltros) {
        barraFiltros.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    activarModoAccion('signos-vitales');
};

const verDatosPaciente = () => {
    mostrarSubmenuInfo.value = false;
    // Scroll suave a la barra de navegación
    const barraFiltros = document.querySelector('.barra-filtros-flotante');
    if (barraFiltros) {
        barraFiltros.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    activarModoAccion('datos-paciente');
};

const gestionarAlergias = () => {
    mostrarSubmenuInfo.value = false;
    // Scroll suave a la barra de navegación
    const barraFiltros = document.querySelector('.barra-filtros-flotante');
    if (barraFiltros) {
        barraFiltros.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    activarModoAccion('alergias');
};

// Función para ver perfil del paciente
const verPerfilPaciente = () => {
    // Scroll suave a la barra de navegación
    const barraFiltros = document.querySelector('.barra-filtros-flotante');
    if (barraFiltros) {
        barraFiltros.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    activarModoAccion('perfil-paciente');
};

// Función para expandir/contraer detalle
/* eslint-disable no-unused-vars */
const toggleExpandirDetalle = () => {
    toggleDetailExpansion();
};
/* eslint-enable no-unused-vars */

// Función para mostrar/ocultar Panel de Acciones (BlocAcciones - panel izquierdo)
const togglePanelAcciones = () => {
    togglePanel('left');
};
</script>

<style scoped>
.barra-filtros-flotante {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(247, 248, 252, 0.98) 100%);
    backdrop-filter: blur(20px);
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.08),
        0 1px 3px rgba(0, 0, 0, 0.04);
    padding: 0.5rem 0.8rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    border-bottom: 1px solid rgba(102, 126, 234, 0.08);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    margin: 0px 5px;
    border-radius: 20px;
}

.controles-vista {
    display: flex;
    gap: 0.25rem;
    align-items: center;
}

.controles-vista button {
    border: none;
    background: transparent;
    padding: 6px 14px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.8125rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
}

.controles-vista button i {
    font-size: 0.9rem;
    transition: transform 0.2s ease;
}

.controles-vista .btn-label {
    font-size: 0.75rem;
    font-weight: 600;
}

/* Estado activo para botones de panel */
.controles-vista button.panel-activo {
    background: linear-gradient(135deg, #2dce89 0%, #26a69a 100%);
    color: white;
    box-shadow: 0 1px 4px rgba(45, 206, 137, 0.25);
}

.controles-vista button.panel-activo:hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 10px rgba(45, 206, 137, 0.35);
}

.controles-vista button.panel-activo:hover i {
    transform: scale(1.08);
}

.controles-vista button.panel-activo:active {
    transform: translateY(0);
}

.filtros-rapidos {
    display: flex;
    gap: 0.4rem;
    flex: 1;
    justify-content: center;
    align-items: center;
    padding: 0 0.5rem;
}

/* Separador vertical */
.separador-vertical {
    width: 2px;
    height: 22px;
    background: linear-gradient(180deg, transparent 0%, rgba(102, 126, 234, 0.2) 50%, transparent 100%);
    margin: 0 0.25rem;
}

.filtros-rapidos button {
    border: none;
    background: transparent;
    padding: 6px 14px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.8125rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    color: #67748e;
}

.filtros-rapidos button i {
    font-size: 0.9rem;
    transition: transform 0.2s ease;
}

/* Estado activo */
.filtros-rapidos button.activo {
    background: linear-gradient(135deg, #2dce89 0%, #26a69a 100%);
    color: white;
    box-shadow: 0 1px 4px rgba(45, 206, 137, 0.25);
}

.filtros-rapidos button.activo:hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 10px rgba(45, 206, 137, 0.35);
}

.filtros-rapidos button.activo:hover i {
    transform: scale(1.08);
}

.filtros-rapidos button.activo:active {
    transform: translateY(0);
}

.btn-label {
    font-size: 0.75rem;
    font-weight: 600;
    white-space: nowrap;
}

/* Estilos del submenú */
.submenu-wrapper {
    position: relative;
    display: inline-block;
}

.submenu-wrapper button {
    display: flex;
    align-items: center;
    gap: 6px;
}

.submenu-icon {
    font-size: 0.6rem;
    margin-left: -2px;
    transition: transform 0.2s ease;
}

.submenu-wrapper:hover .submenu-icon {
    transform: rotate(180deg);
}

.submenu-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12),
        0 2px 8px rgba(0, 0, 0, 0.08);
    padding: 6px;
    min-width: 160px;
    z-index: 1000;
    border: 1px solid rgba(102, 126, 234, 0.1);
}

.submenu-dropdown::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    width: 12px;
    height: 12px;
    background: white;
    border-top: 1px solid rgba(102, 126, 234, 0.1);
    border-left: 1px solid rgba(102, 126, 234, 0.1);
    transform: translateX(-50%) rotate(45deg);
}

.submenu-item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 10px 14px;
    border: none;
    background: transparent;
    border-radius: 8px;
    font-size: 0.8125rem;
    font-weight: 500;
    color: #67748e;
    cursor: pointer;
    transition: all 0.2s ease;
    text-align: left;
}

.submenu-item:hover {
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%);
    color: #667eea;
}

.submenu-item.activo {
    background: linear-gradient(135deg, #2dce89 0%, #26a69a 100%);
    color: white;
}

.submenu-item-icon {
    font-size: 0.9rem;
    width: 16px;
    text-align: center;
}

/* Animación del submenú */
.submenu-fade-enter-active,
.submenu-fade-leave-active {
    transition: all 0.2s ease;
}

.submenu-fade-enter-from {
    opacity: 0;
    transform: translateX(-50%) translateY(-8px);
}

.submenu-fade-leave-to {
    opacity: 0;
    transform: translateX(-50%) translateY(-4px);
}

.acciones-final {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.acciones-final button {
    background: transparent;
    border: none;
    border-radius: 12px;
    color: #94a3b8;
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
}

.acciones-final button::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(102, 126, 234, 0.1);
    opacity: 0;
    border-radius: 12px;
    transition: opacity 0.3s ease;
}

.acciones-final button:hover {
    color: #667eea;
}

.acciones-final button:hover::before {
    opacity: 1;
}

.acciones-final button:active {
    transform: scale(0.95);
}

.acciones-final button.panel-activo {
    color: #475569;
}

.acciones-final button.panel-activo::before {
    background: rgba(102, 126, 234, 0.08);
    opacity: 1;
}

.acciones-final button i {
    font-size: 1rem;
    position: relative;
    z-index: 1;
    transition: transform 0.3s ease;
}

.acciones-final button:hover i {
    transform: scale(1.15);
}

/* Panel de filtros avanzados */
.panel-filtros-avanzados {
    width: 100%;
    max-height: calc(100vh - 8rem);
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.3),
        0 12px 40px rgba(99, 102, 241, 0.2);
    overflow: visible;
    border: 1px solid rgba(99, 102, 241, 0.1);
    position: relative;
}

.filtros-avanzados-content {
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow: visible;
    position: relative;
}

/* Header del modal */
.filtros-header {
    display: flex;
    align-items: center;
    gap: 0.875rem;
    padding: 1.125rem 1.25rem;
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
    border-bottom: none;
    overflow: visible;
    border-radius: 16px 16px 0 0;
}

.header-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.125rem;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.header-text {
    flex: 1;
}

.filtros-titulo {
    font-size: 1rem;
    font-weight: 700;
    color: white;
    margin: 0;
    line-height: 1.2;
}

.filtros-subtitulo {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.9);
    margin: 0.25rem 0 0 0;
    font-weight: 500;
}

.btn-cerrar-filtros {
    background: rgba(255, 255, 255, 0.15);
    border: none;
    color: white;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 8px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.875rem;
    width: 32px;
    height: 32px;
    flex-shrink: 0;
}

.btn-cerrar-filtros:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.08);
}



/* Secciones de filtros */
.filtro-seccion {
    padding: 1rem 1.25rem;
    border-bottom: 1px solid rgba(99, 102, 241, 0.08);
    overflow: visible;
}

.filtro-seccion:last-of-type {
    border-bottom: none;
}

.seccion-header {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    margin-bottom: 0.75rem;
}

.seccion-icono {
    font-size: 1rem;
    color: #6366f1;
    width: 1rem;
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.seccion-label {
    font-size: 0.8125rem;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    line-height: 1;
    display: flex;
    align-items: center;
}

/* Selector de tipo nuevo - Estilo GenderSelect */
.selector-tipo-nuevo {
    margin-top: 0.5rem;
    position: relative;
    z-index: 10;
    overflow: visible;
}

/* Estilos específicos para ChoicesSelect dentro del modal */
.panel-filtros-avanzados .selector-tipo-nuevo .choices-select-wrapper {
    overflow: visible !important;
}

.panel-filtros-avanzados .selector-tipo-nuevo .choices {
    width: 100%;
    margin-bottom: 0;
    overflow: visible !important;
}

.panel-filtros-avanzados .selector-tipo-nuevo select.form-control {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: none !important;
}

/* Input visual - diseño moderno y sutil igual que GenderSelect */
.panel-filtros-avanzados .selector-tipo-nuevo .choices__inner {
    min-height: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    border-radius: 12px;
    border: 1.5px solid #e2e8f0;
    background: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    padding: 6px 40px 6px 14px;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: 0.9375rem;
}

.panel-filtros-avanzados .selector-tipo-nuevo .choices__inner:hover {
    border-color: #cbd5e1;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* Flecha sutil y moderna */
.panel-filtros-avanzados .selector-tipo-nuevo .choices[data-type*="select-one"]::after {
    border: none;
    content: '';
    position: absolute;
    right: 16px;
    top: 50%;
    width: 0;
    height: 0;
    margin-top: -2px;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid #94a3b8;
    pointer-events: none;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.panel-filtros-avanzados .selector-tipo-nuevo .choices[data-type*="select-one"].is-open::after {
    border-top: none;
    border-bottom: 5px solid #667eea;
    margin-top: -3px;
    transform: rotate(0deg);
}

/* Dropdown moderno y sutil - oculto por defecto */
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown {
    display: none !important;
}

.panel-filtros-avanzados .selector-tipo-nuevo .is-open .choices__list--dropdown,
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown.is-active {
    display: block !important;
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    right: 0 !important;
    margin: -1.5px 0 0 0 !important;
    padding: 4px 0 !important;
    border: 1.5px solid #e2e8f0 !important;
    border-top: 1.5px solid transparent !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-bottom-left-radius: 12px !important;
    border-bottom-right-radius: 12px !important;
    background: #ffffff !important;
    z-index: 10001 !important;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08), 0 4px 10px rgba(0, 0, 0, 0.04) !important;
    transform: none !important;
    max-height: 280px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    visibility: visible !important;
    pointer-events: auto !important;
    opacity: 1 !important;
}

/* Elimina cualquier separación o elemento decorativo */
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown::before,
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown::after {
    display: none !important;
}

/* Estado abierto - integración perfecta sin separación */
.panel-filtros-avanzados .selector-tipo-nuevo .is-open .choices__inner {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-bottom: 1.5px solid transparent !important;
    border-color: #e2e8f0;
    box-shadow: 0 0 0 1px rgba(102, 126, 234, 0.1);
    background: #fafbfc;
}

/* Evita flip y cualquier cambio de posición */
.panel-filtros-avanzados .selector-tipo-nuevo .is-flipped .choices__list--dropdown {
    bottom: auto !important;
    top: 100% !important;
    margin: -1.5px 0 0 0 !important;
    transform: none !important;
}

/* Oculta el placeholder vacío */
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown .choices__item[data-value=""],
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown .choices__placeholder {
    display: none !important;
}

/* Scrollbar moderno y elegante */
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown::-webkit-scrollbar {
    width: 6px;
}

.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
    margin: 4px 0;
}

.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #6366f1 0%, #8b5cf6 100%);
    border-radius: 10px;
    border: 2px solid #f1f5f9;
    transition: all 0.2s ease;
}

.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #4f46e5 0%, #7c3aed 100%);
    border-color: #e2e8f0;
    transform: scaleX(1.2);
}

/* Items - diseño sutil y minimalista */
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown .choices__item {
    padding: 10px 16px;
    line-height: 1.5;
    margin: 0;
    font-size: 0.9375rem;
    color: #475569;
    transition: all 0.2s ease;
    cursor: pointer;
    border-left: 2px solid transparent;
    background: transparent;
}

/* Hover muy sutil */
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown .choices__item:hover,
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown .choices__item.is-highlighted {
    background: #f8fafc;
    color: #1e293b;
}

/* Item seleccionado con indicador minimalista */
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown .choices__item.is-selected {
    background: #f1f5f9;
    color: #475569;
    font-weight: 500;
    position: relative;
}

/* Checkmark sutil para item seleccionado */
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown .choices__item.is-selected::after {
    content: '✓';
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #64748b;
    font-weight: 600;
    font-size: 0.875rem;
}

/* Espaciado para primera y última opción */
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown .choices__item:first-child {
    margin-top: 2px;
}

.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown .choices__item:last-child {
    margin-bottom: 2px;
}

/* Animación suave y sutil al abrir */
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--dropdown.is-active {
    animation: fadeInDropdownModal 0.2s ease-out;
}

@keyframes fadeInDropdownModal {
    from {
        opacity: 0;
        transform: translateY(-4px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--single .choices__item {
    font-size: 0.9375rem;
    color: #1e293b;
    font-weight: 500;
}

/* Texto del placeholder más sutil */
.panel-filtros-avanzados .selector-tipo-nuevo .choices__list--single .choices__placeholder {
    opacity: 0.5;
    color: #94a3b8;
}

/* Estilos para ChoicesSelect dentro del filtro expandido (mes) */
.panel-filtros-avanzados .filtro-expandido .choices-select-wrapper {
    overflow: visible !important;
}

.panel-filtros-avanzados .filtro-expandido .choices {
    width: 100%;
    margin-bottom: 0;
    overflow: visible !important;
}

.panel-filtros-avanzados .filtro-expandido select.form-control {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: none !important;
}

.panel-filtros-avanzados .filtro-expandido .choices__inner {
    min-height: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    border-radius: 10px;
    border: 1.5px solid #e2e8f0;
    background: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    padding: 6px 40px 6px 14px;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: 0.875rem;
}

.panel-filtros-avanzados .filtro-expandido .choices__inner:hover {
    border-color: #c7d2fe;
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.1);
}

.panel-filtros-avanzados .filtro-expandido .choices[data-type*="select-one"]::after {
    border: none;
    content: '';
    position: absolute;
    right: 14px;
    top: 50%;
    width: 0;
    height: 0;
    margin-top: -2px;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid #94a3b8;
    pointer-events: none;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.panel-filtros-avanzados .filtro-expandido .choices[data-type*="select-one"].is-open::after {
    border-top: none;
    border-bottom: 5px solid #6366f1;
    margin-top: -3px;
}

.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown {
    display: none !important;
}

.panel-filtros-avanzados .filtro-expandido .is-open .choices__list--dropdown,
.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown.is-active {
    display: block !important;
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    right: 0 !important;
    margin: -1.5px 0 0 0 !important;
    padding: 4px 0 !important;
    border: 1.5px solid #e2e8f0 !important;
    border-top: 1.5px solid transparent !important;
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-bottom-left-radius: 10px !important;
    border-bottom-right-radius: 10px !important;
    background: #ffffff !important;
    z-index: 10002 !important;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08), 0 4px 10px rgba(99, 102, 241, 0.06) !important;
    transform: none !important;
    max-height: 240px !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    visibility: visible !important;
    pointer-events: auto !important;
    opacity: 1 !important;
}

.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown::before,
.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown::after {
    display: none !important;
}

.panel-filtros-avanzados .filtro-expandido .is-open .choices__inner {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-bottom: 1.5px solid transparent !important;
    border-color: #e2e8f0;
    box-shadow: 0 0 0 1px rgba(99, 102, 241, 0.1);
    background: #fafbfc;
}

.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown .choices__item[data-value=""],
.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown .choices__placeholder {
    display: none !important;
}

/* Scrollbar para el mes */
.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown::-webkit-scrollbar {
    width: 6px;
}

.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
    margin: 4px 0;
}

.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #6366f1 0%, #8b5cf6 100%);
    border-radius: 10px;
    border: 2px solid #f1f5f9;
}

.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #4f46e5 0%, #7c3aed 100%);
}

.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown .choices__item {
    padding: 9px 14px;
    line-height: 1.4;
    margin: 0;
    font-size: 0.875rem;
    color: #475569;
    transition: all 0.2s ease;
    cursor: pointer;
    background: transparent;
}

.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown .choices__item:hover,
.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown .choices__item.is-highlighted {
    background: #f8fafc;
    color: #1e293b;
}

.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown .choices__item.is-selected {
    background: #ede9fe;
    color: #6366f1;
    font-weight: 600;
    position: relative;
}

.panel-filtros-avanzados .filtro-expandido .choices__list--dropdown .choices__item.is-selected::after {
    content: '✓';
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #6366f1;
    font-weight: 700;
    font-size: 0.875rem;
}

.panel-filtros-avanzados .filtro-expandido .choices__list--single .choices__item {
    font-size: 0.875rem;
    color: #1e293b;
    font-weight: 500;
}

.panel-filtros-avanzados .filtro-expandido .choices__list--single .choices__placeholder {
    opacity: 0.5;
    color: #94a3b8;
}

/* Grid de botones de tiempo */
.filtros-tiempo-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0.625rem;
    margin-top: 0.5rem;
}

.filtro-tiempo-btn {
    background: #f8fafc;
    border: 1.5px solid #e2e8f0;
    padding: 0.75rem 0.5rem;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.375rem;
    position: relative;
    overflow: hidden;
}

.filtro-tiempo-btn::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
    opacity: 0;
    transition: opacity 0.3s;
    z-index: 0;
}

.filtro-tiempo-icono {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: linear-gradient(135deg, #ddd6fe 0%, #e0e7ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6366f1;
    font-size: 1rem;
    transition: all 0.3s ease;
    position: relative;
    z-index: 1;
}

.filtro-tiempo-texto {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.125rem;
    position: relative;
    z-index: 1;
}

.filtro-tiempo-titulo {
    font-size: 0.75rem;
    font-weight: 700;
    color: #1e293b;
    transition: color 0.3s;
}

.filtro-tiempo-desc {
    font-size: 0.625rem;
    color: #64748b;
    font-weight: 500;
    transition: color 0.3s;
}

.filtro-tiempo-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.2);
    border-color: #c7d2fe;
    background: white;
}

.filtro-tiempo-btn:hover .filtro-tiempo-icono {
    background: linear-gradient(135deg, #c7d2fe 0%, #ddd6fe 100%);
    transform: scale(1.05);
}

.filtro-tiempo-btn.active::before {
    opacity: 1;
}

.filtro-tiempo-btn.active {
    border-color: transparent;
    box-shadow: 0 4px 16px rgba(99, 102, 241, 0.35);
}

.filtro-tiempo-btn.active .filtro-tiempo-icono {
    background: rgba(255, 255, 255, 0.25);
    color: white;
}

.filtro-tiempo-btn.active .filtro-tiempo-titulo,
.filtro-tiempo-btn.active .filtro-tiempo-desc {
    color: white;
}

/* Filtro expandido */
.filtro-expandido {
    margin-top: 0.75rem;
    padding: 0.875rem;
    background: #f8fafc;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
}

/* Input groups modernos */
.input-group-moderno {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.input-label-moderno {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.75rem;
    font-weight: 600;
    color: #475569;
    margin: 0;
}

.input-label-moderno i {
    font-size: 0.8125rem;
    color: #6366f1;
}

.input-moderno {
    width: 100%;
    padding: 0.625rem 0.875rem;
    border: 1.5px solid #e2e8f0;
    border-radius: 8px;
    font-size: 0.8125rem;
    color: #1e293b;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    background: white;
    font-weight: 500;
}

.input-moderno:hover {
    border-color: #c7d2fe;
    box-shadow: 0 2px 6px rgba(99, 102, 241, 0.08);
}

.input-moderno:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

/* Estilos para el DatePicker dentro del modal */
.filtro-expandido .form-control {
    min-height: 44px;
    height: 44px;
    border-radius: 12px;
    border: 1.5px solid #e2e8f0;
    background: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    padding: 6px 14px;
    font-size: 0.9375rem;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
}

.filtro-expandido .form-control:hover {
    border-color: #cbd5e1;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.filtro-expandido .form-control:focus {
    outline: none;
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

/* Asegurar que el calendario de flatpickr se vea por encima del modal */
:deep(.flatpickr-calendar) {
    z-index: 10000 !important;
    border-radius: 12px !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15) !important;
    border: 1px solid #e2e8f0 !important;
}

:deep(.flatpickr-day.selected) {
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
    border-color: #6366f1 !important;
}

:deep(.flatpickr-day.selected:hover) {
    background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%) !important;
}

/* Contenedor de rango de fechas */
.fecha-rango-container {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 0.75rem;
    align-items: center;
}

.separador-fecha {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6366f1;
    font-size: 0.875rem;
    padding-top: 1.25rem;
}

/* Footer con botones de acción */
.filtros-footer {
    display: flex;
    gap: 0.625rem;
    padding: 1rem 1.25rem;
    background: #f8fafc;
    border-top: 1px solid rgba(99, 102, 241, 0.08);
    border-radius: 0 0 16px 16px;
}

.btn-limpiar {
    flex: 1;
    background: white;
    border: 1.5px solid #e2e8f0;
    color: #64748b;
    border-radius: 8px;
    padding: 0.625rem 0.875rem;
    font-size: 0.8125rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
}

.btn-limpiar:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    color: #475569;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.btn-aplicar-moderno {
    flex: 2;
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
    color: white;
    border: none;
    border-radius: 8px;
    padding: 0.625rem 1rem;
    font-size: 0.8125rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    position: relative;
    overflow: hidden;
}

.btn-aplicar-moderno::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, transparent 100%);
    opacity: 0;
    transition: opacity 0.3s;
}

.btn-aplicar-moderno:hover::before {
    opacity: 1;
}

.btn-aplicar-moderno:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.4);
}

.btn-aplicar-moderno:active {
    transform: translateY(0);
}

/* Animación de expansión */
.expand-enter-active,
.expand-leave-active {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    max-height: 500px;
    overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
    max-height: 0;
    opacity: 0;
    transform: translateY(-10px);
}

/* Animaciones mejoradas */
/* Animación para panel de historial reciente (derecha) */
.panel-historial-reciente.slide-down-enter-active {
    animation: slideDownInRight 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.panel-historial-reciente.slide-down-leave-active {
    animation: slideDownOutRight 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideDownInRight {
    from {
        opacity: 0;
        transform: translateY(-15px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes slideDownOutRight {
    from {
        opacity: 1;
        transform: translateY(0) scale(1);
    }

    to {
        opacity: 0;
        transform: translateY(-15px) scale(0.95);
    }
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter-from {
    opacity: 0;
    transform: translateY(-15px) scale(0.98);
}

.slide-fade-leave-to {
    opacity: 0;
    transform: translateY(-15px) scale(0.98);
}

/* Panel de Historial Reciente */
.panel-historial-reciente {
    position: absolute;
    top: 100%;
    right: 1.5rem;
    width: 340px;
    max-width: 90vw;
    background: white;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15),
        0 5px 20px rgba(102, 126, 234, 0.1);
    margin-top: 0.75rem;
    z-index: 200;
    overflow: hidden;
    border: 1px solid rgba(102, 126, 234, 0.1);
}

.historial-reciente-content {
    padding: 1rem;
}

.historial-titulo {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    color: #667eea;
    font-size: 0.95rem;
    font-weight: 700;
    margin-bottom: 0.75rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid rgba(102, 126, 234, 0.1);
    position: relative;
}

.historial-titulo i {
    font-size: 1rem;
}

.btn-cerrar-historial {
    margin-left: auto;
    background: transparent;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    padding: 0.3rem 0.5rem;
    border-radius: 6px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
}

.btn-cerrar-historial:hover {
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
    transform: scale(1.1);
}

.btn-cerrar-historial i {
    font-size: 1rem;
}

.historial-lista {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    max-height: 320px;
    overflow-y: auto;
    padding-right: 0.5rem;
}

.historial-vacio {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 1rem;
    color: #8492a6;
    text-align: center;
}

.historial-vacio i {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    opacity: 0.4;
}

.historial-vacio p {
    font-size: 0.9rem;
    font-weight: 500;
    margin: 0;
}

/* Scrollbar personalizado */
.historial-lista::-webkit-scrollbar {
    width: 5px;
}

.historial-lista::-webkit-scrollbar-track {
    background: #f1f3f5;
    border-radius: 10px;
}

.historial-lista::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 10px;
}

.historial-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem;
    border-radius: 10px;
    background: linear-gradient(135deg, #f7f8fa 0%, #ffffff 100%);
    border: 1px solid rgba(102, 126, 234, 0.08);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.historial-item:hover {
    transform: translateX(5px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
    border-color: #667eea;
}

.item-icono {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 0.95rem;
    flex-shrink: 0;
}

.item-info {
    flex: 1;
    min-width: 0;
}

.item-titulo {
    font-size: 0.85rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.2rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.item-fecha {
    font-size: 0.75rem;
    color: #8492a6;
    font-weight: 500;
}

/* ========================================
   PANEL HISTORIAL MODERNO
======================================== */
.panel-historial-reciente-moderno {
    position: absolute;
    top: calc(100% + 0.5rem);
    right: 0;
    width: 450px;
    max-width: 95vw;
    z-index: 9999;
}

/* ========================================
   ESTILOS RESPONSIVOS PARA EL MODAL CENTRADO
======================================== */
@media (max-width: 768px) {
    .modal-dialog-filtros {
        max-width: calc(100vw - 2rem);
        padding: 0 1rem;
    }

    .panel-filtros-avanzados {
        max-height: calc(100vh - 6rem);
        border-radius: 14px;
    }

    .filtros-header {
        padding: 1rem 1.125rem;
    }

    .header-icon {
        width: 36px;
        height: 36px;
        font-size: 1rem;
    }

    .filtros-titulo {
        font-size: 0.9375rem;
    }

    .filtros-subtitulo {
        font-size: 0.6875rem;
    }

    .filtro-seccion {
        padding: 0.875rem 1.125rem;
    }

    .filtros-tiempo-grid {
        grid-template-columns: 1fr;
        gap: 0.5rem;
    }

    .filtro-tiempo-btn {
        flex-direction: row;
        justify-content: flex-start;
        padding: 0.75rem;
        gap: 0.75rem;
    }

    .filtro-tiempo-icono {
        width: 32px;
        height: 32px;
        font-size: 0.9375rem;
    }

    .filtro-tiempo-texto {
        align-items: flex-start;
    }

    .fecha-rango-container {
        grid-template-columns: 1fr;
        gap: 0.625rem;
    }

    .separador-fecha {
        padding-top: 0;
        transform: rotate(90deg);
        font-size: 0.75rem;
    }

    .filtros-footer {
        padding: 0.875rem 1.125rem;
        flex-direction: column;
    }

    .btn-limpiar,
    .btn-aplicar-moderno {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .modal-dialog-filtros {
        max-width: calc(100vw - 1.5rem);
        padding: 0 0.75rem;
    }

    .panel-filtros-avanzados {
        max-height: calc(100vh - 4rem);
        border-radius: 12px;
    }

    .filtros-header {
        padding: 0.875rem 1rem;
        border-radius: 12px 12px 0 0;
    }

    .header-icon {
        width: 32px;
        height: 32px;
        font-size: 0.9375rem;
    }

    .filtros-titulo {
        font-size: 0.875rem;
    }

    .filtros-subtitulo {
        font-size: 0.625rem;
    }

    .filtro-seccion {
        padding: 0.75rem 1rem;
    }

    .seccion-label {
        font-size: 0.75rem;
    }

    .filtro-tiempo-titulo {
        font-size: 0.6875rem;
    }

    .filtro-tiempo-desc {
        font-size: 0.5625rem;
    }

    .filtros-footer {
        border-radius: 0 0 12px 12px;
    }
}

/* Mejora para pantallas muy pequeñas en altura */
@media (max-height: 650px) {
    .panel-filtros-avanzados {
        max-height: calc(100vh - 3rem);
    }

    .filtro-seccion {
        padding: 0.75rem 1.125rem;
    }

    .filtros-header {
        padding: 0.875rem 1.125rem;
    }

    .filtros-footer {
        padding: 0.875rem 1.125rem;
    }
}

/* Asegurar que el modal se vea bien en landscape móvil */
@media (max-width: 768px) and (orientation: landscape) {
    .panel-filtros-avanzados {
        max-height: calc(100vh - 2rem);
    }

    .filtros-tiempo-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .filtro-tiempo-btn {
        flex-direction: column;
        align-items: center;
    }

    .filtro-tiempo-texto {
        align-items: center;
    }
}

/* Estilos específicos para el modal dentro del Teleport que va fuera del componente */
/* Mover estos estilos del modal al body para que funcionen correctamente */
.modal-backdrop-filtros {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    background-color: rgba(0, 0, 0, 0.5) !important;
    z-index: 9998 !important;
    opacity: 0;
    animation: fadeInBackdrop 0.3s forwards !important;
    cursor: pointer !important;
}

.modal-dialog-filtros {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    z-index: 9999 !important;
    width: 100% !important;
    max-width: 500px !important;
    padding: 0 1rem !important;
}

.modal-animated-filtros {
    animation: modalSlideInFiltros 0.4s cubic-bezier(0.34, 1.56, 0.64, 1), modalFadeInFiltros 0.4s ease-out !important;
}

@keyframes modalSlideInFiltros {
    0% {
        transform: translate(-50%, calc(-50% + 40px));
    }

    100% {
        transform: translate(-50%, -50%);
    }
}

@keyframes modalFadeInFiltros {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes fadeInBackdrop {
    to {
        opacity: 1;
    }
}

/* Responsive para el modal en body */
@media (max-width: 768px) {
    .modal-dialog-filtros {
        max-width: calc(100vw - 2rem) !important;
        padding: 0 1rem !important;
    }
}

@media (max-width: 480px) {
    .modal-dialog-filtros {
        max-width: calc(100vw - 1.5rem) !important;
        padding: 0 0.75rem !important;
    }
}
</style>
